import React from "react";
import {Button, Input, Space, Table, Tag, Tooltip} from "antd";
import Highlighter from 'react-highlight-words';
import {SearchOutlined} from '@ant-design/icons';
import {renderRecord} from "../../utils/util";
import {getMappingTableWithPrePostVals} from "./mappingQA.util";
import {isObject} from "lodash";

export default class MappingQA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            columns: [
                {
                    title: '',
                    key: 'suggest',
                    width: '3%',
                    dataIndex: 'suggest',
                    render: tags => (
                        <>
                            {tags.map(tag => {
                                let color = 'green';
                                let val = 'OK'
                                if (tag.error) {
                                    color = 'red';
                                    val = 'X'
                                } else if (tag.warning) {
                                    color = 'gold'
                                    val = '?'
                                }
                                return (
                                    <span key={Math.random()}>
                                        <Tooltip placement="top" title={tag.message}>
                                            <Tag style={{cursor: 'default'}} color={color} key={tag}>
                                                {val}
                                            </Tag>
                                        </Tooltip>
                                    </span>

                                );
                            })}
                        </>
                    ),
                },
                {
                    title: 'Path',
                    dataIndex: 'path',
                    key: 'path',
                    width: '30%',
                    ...this.getColumnSearchProps('path'),
                },
                {
                    title: 'Pre-Transform',
                    dataIndex: 'mapping',
                    key: 'mapping',
                    width: '30%',
                    ...this.getColumnSearchProps('mapping'),
                    render: (_, record) => renderRecord(record, 'mapping')
                },
                {
                    title: 'Transformed',
                    dataIndex: 'value',
                    key: 'value',
                    width: '30%',
                    ...this.getColumnSearchProps('value'),
                },
                // {
                //     title: 'Mapping Version',
                //     dataIndex: 'version',
                //     key: 'version',
                //     width: '8%'
                // }
            ]
        };
    }

    componentDidMount = () => {
        const {resource, mappings} = this.props;
        let data = getMappingTableWithPrePostVals(resource, mappings);
        this.setState({data});
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{marginBottom: 8, display: 'block'}}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined/>}
                        size="small"
                        style={{width: 90}}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined}}/>,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                !isObject(text) ? text.toString() : ''
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({searchText: ''});
    };

    render() {
        const {columns, data} = this.state;
        return (
            <Table size="small"
                className="mapping-qa-table"
                scroll={{y: 500}}
                pagination={false}
                columns={columns}
                dataSource={data}
            />
        )
    }
}